<template>
    <v-flex>
        <v-layout row wrap mt-4>
            <v-flex xs12 md6 mb-4>
                <v-flex>
                <tool-tip-icon text="U kunt geselecteerde extra velden van volgorde veranderen</br> door ze naar boven/beneden te slepen en daarna op te slaan"></tool-tip-icon>                                                                                                             
                Geselecteerde extra velden voor alle point of interests 
                </v-flex>
                <draggable v-model="selectedCustomFields">
                <transition-group>
                    <v-flex v-for="field of selectedCustomFields" :key="field.id" pl-3>
                    <v-chip label style="padding-right:4px">
                        <v-icon left >label</v-icon>
                        <label>{{field.name}} ({{field.type.name}})</label>
                        <v-icon class="fas fa-times" @click="removeFieldFromGroup(field)" right></v-icon>                 
                    </v-chip>                                                                                                                                       
                    </v-flex>
                </transition-group>
                </draggable>
                <v-flex v-if="selectedCustomFields.length==0" pl-4>
                <i>Geen extra velden geselecteerd voor deze groep</i>
                </v-flex>
            </v-flex>                                                  
            <v-flex xs12 md6>
                <v-layout column>
                    <v-flex mb-1> 
                    <tool-tip-icon text="Klik op een beschikbaar extra veld om deze toe te voegen aan geselecteerde extra velden </br> Sla deze daarna op om uw wijzigingen door te voeren"></tool-tip-icon>
                    Beschikbare extra velden:
                    </v-flex>      
                    <v-flex pl-3>      
                        <v-text-field
                            @keyup="search(vm)"
                            v-model="searchMixin.searchText"
                            prepend-inner-icon="fas fa-search"
                            dense
                            label="Zoek een extra veld die u wilt voegen"
                            solo>                    
                        </v-text-field>                                                                                                                                                  
                        </v-flex>
                    <v-dialog v-model="newCustomFieldDialog" persistent max-width="600">
                        <v-flex pl-3 slot="activator">
                            <v-chip label outline color="green">
                                <v-icon left class="fas fa-plus" color="green" @click="addNewCustomField()"></v-icon> Nieuw extra veld aanmaken
                            </v-chip>  
                        </v-flex>
                        <v-card>
                            <v-card-title class="headline">Nieuw extra veld toevoegen</v-card-title>
                            <v-card-text>
                            <custom-field-form
                                newOnSave="1"
                                @saved="customFieldSaved"
                                @cancelClicked="customFieldCanceled"
                            >
                            </custom-field-form>
                            </v-card-text>
                            <v-card-actions>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>                                      
                    <v-flex v-for="field of unselectedCustomFields" :key="field.id" pl-3 >
                    <v-chip label outline @click="addCustomField(field)">
                        <v-icon left>label</v-icon>
                        {{field.name}} ({{field.type.name}})
                    </v-chip>                                                                                                                                       
                    </v-flex>     
                    <v-pagination v-if="customFieldsPagination && customFieldsPagination.pagination && customFieldsPagination.pagination.count > 0"             
                        v-model="customFieldsPagination.pagination.current_page"
                        :length="customFieldsPagination.pagination.total_pages"                           
                        @input="loadPage">
                    </v-pagination>                                                                                  
                </v-layout>   
            </v-flex>       
        </v-layout>   
        <v-layout row mt-4>
            <v-btn                          
                color=""                      
                @click="clearCurrent"> 
                annuleren
            </v-btn>                                                                                                         
            <v-spacer></v-spacer>                                         
            <v-btn                                                
                color="success"
                @click="saveCustomFieldsOnGroup">
                Opslaan
            </v-btn>                        
        </v-layout>   
    </v-flex>                       
</template>

<script>
    import * as types from "../../store/types"
    import { mapGetters } from 'vuex'
    import draggable from 'vuedraggable'
    import searchMixin from "../../plugins/mixins/SearchWithPagerMixin"    
    import customFieldForm from '../../components/customFields/CustomFieldForm'
    import ToolTipIcon from '../../components/global/ToolTipIcon'

    export default {
        mixins:[searchMixin],        
        components: {    
            customFieldForm,
            ToolTipIcon,
            draggable
        },        
        data() {
            return  {
                vm:this,
                selectedCustomFields:[],
                newCustomFieldDialog:false               
            }
        },         
        computed: {
            ...mapGetters({
                allCustomFields: types.CUSTOM_FIELDS,
                customFieldsPagination: types.CUSTOM_FIELDS_PAGINATION, 
                geoZoneCustomFields: types.GEO_ZONE_CUSTOM_FIELDS,
            }),
            unselectedCustomFields(){   
                let result = []
                let selected = this.selectedCustomFields
                let selectable = this.allCustomFields
                
                selectable.forEach( (s1) => {        
                    let found = false
                    selected.forEach( (s2) => {        
                        if(s1.id == s2.id){
                            found = true
                        }
                    })
                    if(!found){
                        result.push(s1)
                    }
                })
                return result
            }
        },
        methods: {
            customFieldCanceled(){
                this.newCustomFieldDialog=false                               
            },
            removeFieldFromGroup(removeField){
                let result = []
                this.selectedCustomFields.forEach((field) => {
                    if(field.id != removeField.id){
                        result.push(field)        
                    }
                })
                this.selectedCustomFields = result
            },
            searchCustomFields: _.debounce((compObj)=>{    
                compObj.loadPage(1, true)
            },300),               
            addNewCustomField(){
                this.newCustomFieldDialog = false
            },
            addCustomField(field){
                this.selectedCustomFields.push(field)
            },
            clearCurrent(){
                this.$emit("canceled");
            },
            saveCustomFieldsOnGroup(){
                let i=0
                let saveFields=[]

                this.selectedCustomFields.forEach((field) => {
                    saveFields.push({custom_field_id:field.id, sort_order:i})
                    i++
                })

                this.$store.dispatch(types.SAVE_CUSTOM_FIELDS_ON_GEO_ZONE, {data:{customFields:saveFields}} ).then((res) => {                                                
                    // reload list after save  
                    this.$notify("Extra velden zijn aangepast", {color:'success', timeout: 4000, icon:'check'})                             
                })
            },    
            customFieldSaved(){                
                this.$notify("Extra veld aangemaakt", {color:'success', timeout: 4000, icon:'check'})                             
                this.newCustomFieldDialog=false
                this.loadGeoZoneCustomFields()
            },  
            customFieldCanceled(){
                this.newCustomFieldDialog=false
            },
            loadGeoZoneCustomFields(){
                this.$store.dispatch(types.GEO_ZONE_CUSTOM_FIELDS,{params:{include:"customField, customField.type"}}).then(() => {
                    this.selectedCustomFields=[]
                    this.geoZoneCustomFields.forEach((geoCustomField) => {
                        this.selectedCustomFields.push( geoCustomField.customField )
                    })
                 })                              
            }                                  
        },        
        mounted() {
            this.searchMixin.perPage              = 10
            this.searchMixin.payloadIncludes      = "type"
            this.searchMixin.searchStore          = types.CUSTOM_FIELD_SEARCH
            this.searchMixin.defaultStore         = types.CUSTOM_FIELDS    
            this.reset()
            this.loadGeoZoneCustomFields()
        },                   
    }
</script>

<style lang="scss" scoped>

</style>